export enum LocalizedUtcTimeUnitFormat {
    Short,
    Long,
}
